module.exports = __webpack_public_path__ + "img/remove.738459bb.svg";